import { Color } from "../enums/Color";

const button = {
    height: "40px",
    padding: "0 24px",
    fontSize: "15px",
    fontWeight: "bold",
    borderRadius: "8px",
    cursor: "pointer"
};

const backdrop = {
    backgroundColor: Color.Black,
    opacity: 0.15,
    position: "fixed" as "fixed",
    left: "0",
    right: "0",
    bottom: "0",
    top: "0"
};

export const videoPayoutsPage = {
    mobile: {
        margin: "16px 4%",
        heading: {
            textAlign: "center" as "center",
            margin: "0 0 12px 0"
        },
        toolbar: {
            display: "flex",
            flexDirection: "row" as "row",
            flexWrap: "wrap" as "wrap",
            // Top-aligned because the shared Select keeps bottom padding under its label
            alignItems: "flex-start" as "flex-start",
            gap: "12px"
        },
        tabButton: {
            ...button,
            padding: "0 16px",
            background: "transparent",
            color: Color.ChathamsBlue,
            border: "2px solid " + Color.Green,
            active: {
                background: Color.Green,
                color: Color.White
            }
        },
        dateWrapper: {
            display: "flex",
            flexDirection: "row" as "row",
            alignItems: "center",
            gap: "8px",
            height: "40px"
        },
        dateLabel: {
            fontWeight: "bold",
            color: Color.DeepAsh
        },
        dateInput: {
            height: "40px",
            padding: "0 12px",
            fontSize: "15px",
            border: "2px solid " + Color.Green,
            borderRadius: "8px",
            boxSizing: "border-box" as "border-box"
        },
        teacherSelect: {
            wrapper: {
                width: "260px",
                marginTop: "0",
                marginLeft: "unset"
            },
            labelWrapper: {
                height: "40px",
                padding: "0 12px",
                boxSizing: "border-box" as "border-box",
                alignItems: "center",
                borderRadius: "8px"
            },
            label: {
                fontSize: "15px"
            },
            hover: {
                width: "250px",
                height: "320px",
                left: "unset",
                padding: "5px"
            }
        },
        backButton: {
            ...button,
            background: Color.White,
            color: Color.DeepAsh,
            border: "2px solid " + Color.MiddleAsh,
            marginLeft: "auto"
        },
        summary: {
            margin: "16px 0 0 0",
            color: Color.DeepAsh,
            fontWeight: "bold"
        },
        table: {
            width: "100%",
            margin: "16px 0 0 0",
            border: "2px solid " + Color.Green,
            borderCollapse: "collapse" as "collapse",
            tableLayout: "fixed" as "fixed",
            fontSize: "14px",
            header: {
                height: "44px",
                backgroundColor: Color.Green,
                color: Color.White
            },
            tr: {
                border: "2px solid " + Color.Green,
                textAlign: "center" as "center",
                verticalAlign: "top" as "top"
            },
            // History rows open the payout detail dialog
            clickableTr: {
                cursor: "pointer"
            },
            hoveredTr: {
                backgroundColor: Color.LightAsh
            },
            idColumn: { width: "60px" },
            teacherColumn: {},
            purchasesColumn: { width: "170px" },
            amountColumn: { width: "220px" },
            bankColumn: {},
            transferColumn: { width: "220px" },
            actionColumn: { width: "130px" },
            leftCell: {
                textAlign: "left" as "left",
                padding: "10px"
            },
            primaryText: {
                fontWeight: "bold",
                marginBottom: "4px"
            },
            mutedText: {
                fontSize: "12px",
                color: Color.SharpAsh
            },
            netText: {
                fontWeight: "bold",
                color: Color.Viridian,
                marginTop: "4px"
            },
            warningText: {
                color: Color.HarvestGold,
                fontWeight: "bold"
            },
            link: {
                display: "inline-block",
                marginTop: "4px",
                color: Color.ChathamsBlue,
                fontWeight: "bold"
            },
            actionButton: {
                ...button,
                height: "36px",
                padding: "0 16px",
                margin: "10px 0",
                background: Color.Green,
                color: Color.White,
                border: "none",
                disabled: {
                    opacity: 0.4,
                    cursor: "not-allowed"
                }
            }
        },
        // Shared by the transfer dialog and the read-only payout detail dialog
        payoutDialog: {
            backdrop: backdrop,
            content: {
                background: Color.White,
                position: "fixed" as "fixed",
                top: "4%",
                left: "3%",
                width: "88%",
                maxHeight: "88vh",
                overflowY: "auto" as "auto",
                padding: "20px 3%",
                borderRadius: "10px",
                zIndex: "4",
                boxShadow: "1px 0px 7px rgba(0,0,0,0.5)"
            },
            title: {
                margin: "0 0 4px 0",
                color: Color.ChathamsBlue
            },
            mutedText: {
                fontSize: "13px",
                color: Color.SharpAsh
            },
            amountRow: {
                display: "flex",
                flexDirection: "row" as "row",
                flexWrap: "wrap" as "wrap",
                gap: "12px",
                margin: "16px 0"
            },
            amountTile: {
                flex: "1 1 140px",
                padding: "10px 14px",
                backgroundColor: Color.LightAsh,
                borderRadius: "8px",
                value: {
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: Color.DeepAsh
                },
                net: {
                    color: Color.Viridian
                },
                label: {
                    fontSize: "12px",
                    color: Color.SharpAsh
                }
            },
            bank: {
                padding: "12px 14px",
                border: "2px solid " + Color.Green,
                borderRadius: "8px",
                lineHeight: "1.6"
            },
            bankLabel: {
                fontWeight: "bold"
            },
            transferDetails: {
                marginTop: "12px",
                lineHeight: "1.6"
            },
            link: {
                color: Color.ChathamsBlue,
                fontWeight: "bold"
            },
            sectionTitle: {
                margin: "20px 0 8px 0",
                fontWeight: "bold",
                color: Color.DeepAsh
            },
            subjectGroup: {
                marginBottom: "12px",
                border: "1px solid " + Color.MiddleAsh,
                borderRadius: "8px",
                overflow: "hidden"
            },
            subjectHeader: {
                display: "flex",
                flexDirection: "row" as "row",
                justifyContent: "space-between",
                gap: "12px",
                padding: "8px 12px",
                backgroundColor: Color.AliceBlue,
                subjects: {
                    fontWeight: "bold",
                    color: Color.ChathamsBlue
                },
                total: {
                    fontWeight: "bold",
                    whiteSpace: "nowrap" as "nowrap"
                }
            },
            purchaseTable: {
                width: "100%",
                borderCollapse: "collapse" as "collapse",
                fontSize: "13px",
                th: {
                    textAlign: "left" as "left",
                    padding: "6px 12px",
                    color: Color.SharpAsh,
                    fontWeight: "normal"
                },
                td: {
                    textAlign: "left" as "left",
                    padding: "6px 12px",
                    borderTop: "1px solid " + Color.Ash,
                    verticalAlign: "top" as "top"
                },
                amount: {
                    textAlign: "right" as "right",
                    whiteSpace: "nowrap" as "nowrap"
                }
            },
            field: {
                marginTop: "16px"
            },
            label: {
                display: "block",
                fontWeight: "bold",
                color: Color.DeepAsh,
                margin: "0 0 6px 0"
            },
            textInput: {
                width: "100%",
                height: "40px",
                padding: "0 12px",
                fontSize: "15px",
                border: "2px solid " + Color.Green,
                borderRadius: "8px",
                boxSizing: "border-box" as "border-box"
            },
            fileButton: {
                display: "inline-block",
                padding: "8px 16px",
                color: Color.ChathamsBlue,
                border: "2px solid " + Color.ChathamsBlue,
                borderRadius: "8px",
                fontWeight: "bold",
                cursor: "pointer"
            },
            removeFile: {
                marginLeft: "12px",
                color: Color.Red,
                cursor: "pointer"
            },
            buttonWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "12px",
                marginTop: "24px"
            },
            cancelButton: {
                ...button,
                background: Color.White,
                color: Color.DeepAsh,
                border: "2px solid " + Color.MiddleAsh
            },
            confirmButton: {
                ...button,
                background: Color.Green,
                color: Color.White,
                border: "2px solid " + Color.Green
            },
            disabledButton: {
                opacity: 0.5,
                cursor: "not-allowed"
            }
        }
    },
    desktop: {
        payoutDialog: {
            content: {
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "56%",
                padding: "24px 2%"
            }
        }
    }
}
